import React, { useEffect, useState } from "react";
import { injectIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import logoMedical from "../../assets/logo-medical.png";
import martina from "../../assets/martina.png";
import { getTexts } from "../../api/text";
import NextButton from "../../components/NextButton";
import PatientAvatar from "../../components/PatientAvatar";
import { ROUTES } from "../../utils/constants";
import { getScenarioByScreen } from "../../utils/helpers";

function Scenario2Result({ intl }) {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const location = useLocation();
	const group = useSelector((state) => state.group);
	const scenarioNum = getScenarioByScreen(location.pathname);
	const defaultContent = "<p style=\"text-align:center;\">Así pues, el diagnóstico de Martina es:&nbsp;</p><p style=\"text-align:center;\"><span style=\"color:hsl(90, 75%, 60%);\"><strong>Nefritis lúpica clase IV Índice de actividad: 12/24; índice de cronicidad: 1/12</strong></span></p><p style=\"text-align:center;\">Ahora hay que valorar un tratamiento para la paciente. Pero antes…</p>";
	const [content, setContent] = useState(defaultContent);

	useEffect(() => {
		const gameId = group?.game;
		if (!gameId) return;
		getTexts({ game: gameId })
			.then((res) => {
				if (res.status === 200 && Array.isArray(res.data)) {
					const map = res.data.reduce((acc, t) => ({ ...acc, [t.key]: t.value }), {});
					if (map["scenario2.result.content"] != null) setContent(map["scenario2.result.content"]);
				}
			})
			.catch(() => {});
	}, [group?.game]);

	return (
		<div className="h-100">
			<div className="container-fluid bg-internas">
				<div style={{ paddingTop: "6vh", paddingLeft: "6vh" }}>
					<img width={240} src={logoMedical} alt="" />
				</div>
				<div className="row d-flex justify-content-center align-items-center mt-5 pt-5">
					<div className="col-9">
						<div className="ms-5 ps-4 d-flex align-items-center">
							<PatientAvatar gameId={group?.game} defaultSrc={martina} width={350} />
							<div className="ms-4 txtWhite txt20" style={{ maxWidth: 520 }} dangerouslySetInnerHTML={{ __html: content || defaultContent }} />
						</div>
					</div>
				</div>
			</div>
			<div
				className="container"
				style={{
					position: "absolute",
					bottom: "8vh",
				}}
			>
				<div className="d-flex justify-content-end">
					<NextButton
						navigateTo={ROUTES.TRANSITION_SCENARIOS}
						activeScenario={scenarioNum + 1}
					/>
				</div>
			</div>
		</div>
	);
}

export default injectIntl(Scenario2Result);
